import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
    const { pathname, search } = useLocation();

    useEffect(() => {
        // Se o Lenis estiver ativo, usar o scrollTo dele para garantir que funcione
        if ((window as any).lenis) {
            (window as any).lenis.scrollTo(0, { immediate: true });
        } else {
            // Fallback para scroll padrão
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'instant' as ScrollBehavior
            });
        }
    }, [pathname, search]);

    return null;
}
